import React from 'react';
import { ClinicalActionPlan } from '../types';

interface ClinicalActionCardProps {
  plan: ClinicalActionPlan | null;
}

const ACTION_ITEMS: { key: keyof ClinicalActionPlan; label: string }[] = [
  { key: 'imaging', label: 'Imaging' },
  { key: 'rhythmMonitoring', label: 'Rhythm Monitoring' },
  { key: 'exerciseGuidance', label: 'Exercise' },
  { key: 'familyScreening', label: 'Family Screening' },
  { key: 'geneticCounseling', label: 'Genetic Counseling' },
  { key: 'reclassificationTimeline', label: 'Reclassification' },
  { key: 'additionalWorkup', label: 'Additional Workup' },
];

const ClinicalActionCard: React.FC<ClinicalActionCardProps> = ({ plan }) => {
  if (!plan) return null;

  const activeItems = ACTION_ITEMS.filter(item => plan[item.key] != null);
  if (activeItems.length === 0) return null;

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
      <h3 className="text-lg font-semibold text-slate-800 mb-4 flex items-center gap-2">
        <span>📋</span> Recommended Clinical Actions
      </h3>
      <div className="space-y-4">
        {activeItems.map(item => (
          <div key={item.key} className="border-l-2 border-slate-100 pl-3">
            <span className="text-xs font-semibold text-slate-400 uppercase tracking-wide block mb-1">
              {item.label}
            </span>
            <p className="text-sm text-slate-700 leading-relaxed">
              {plan[item.key]}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClinicalActionCard;
